export default {
    mapLandmarkDeleteLandmarkGroup_title:'Eliminar Grupos de Puntos de Referencia',
    mapLandmarkDeleteLandmarkGroup_move: 'Mover a',
    mapLandmarkDeleteLandmarkGroup_deleteAll: 'Eliminar (Todos los Puntos de Referencia en estos grupos serán borrados)',
    mapLandmarkDeleteLandmarkGroup_success: "Grupos de Puntos de Referencia eliminados",
    mapLandmarkDeleteLandmarkGroup_question1: '¿Que desea hacer con los Puntos de Referencia que pertenecen a estos grupos?',
    mapLandmarkDeleteLandmarkGroup_deleteAction: 'Acciones diponibles',
    mapLandmarkDeleteLandmarkGroup_question2: '¿Está seguro que desea eliminar estos grupos de Puntos de Referencia?',
    mapLandmarkDeleteLandmarkGroup_warning: 'Está acción no se puede deshacer',
}